var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.chartLegendData.length > 0)?_c('div',{staticClass:"legend"},_vm._l((_vm.chartLegendData),function(legend){return _c('div',{key:legend.label,staticClass:"legend-item"},[_c('span',{staticClass:"legend-color",style:({ backgroundColor: legend.color })}),_vm._v(" "+_vm._s(legend.label)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }